import { render } from "./ConfirmationView.vue?vue&type=template&id=63ed149a&scoped=true&ts=true"
import script from "./ConfirmationView.vue?vue&type=script&lang=ts"
export * from "./ConfirmationView.vue?vue&type=script&lang=ts"

import "./ConfirmationView.vue?vue&type=style&index=0&id=63ed149a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ed149a"]])

export default __exports__